export const routeDetail = [
  '/home/courseDetail',
  '/home/seminar',
  '/home/information',
  '/home/courseToptic',
  '/znWeb/exam/detail.html',
  '/liveRoom',
  '/home/myTrainingDetail',
  '/home/studyDetail',
  '/home/allKnowledgeLib',
  '/home/knowledgeLibDetail',
  '/home/myFiles',
  '/home/studyMapList',
  '/home/myCourse',
  '/home/myTrainingClass',
  '/home/rankList',
  '/home/myIntegration/detail',
  '/home/myIntegration/rule',
  '/home/myQuestionnaire',
  '/home/myExam/push',
  '/home/examDetail',
  'home/examScoreRank',
  '/home/certificate/list',
  '/home/openTrainingDetail',
  '/home/openTrainingSign',
  '/home/myOrder',
  '/home/myOrderDetail',
  '/home/refundSale',
  '/home/myTrainingProjectList',
]

// 详情样式与其他详情样式不通
export const isCourse = ['/home/courseDetail', '/liveRoom']
